module.exports = __webpack_public_path__ + "mo/img/board_01.3bfba1d4.png";